import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export default function ProtectedRoute () {
    const auth = useAuth();

    if (auth.isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center w-100" style={{minHeight: '100vh'}}>
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return auth.isAuthenticated ? <Outlet/> : <Navigate to="/login"/> 
}